// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 273) return "static/chunks/273-b87d1ecd81bcee2c.js";
	if (chunkId === 523) return "static/chunks/523-0d71f234f28a985b.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"687":"cb7c9664a57b9787","705":"5a1cb46c5a6c1ad8"}[chunkId] + ".js";
};